import { useContext } from 'react'
import UserContext from 'shared/contexts/user'
import styled from 'styled-components'
import { BUTTON_ACTIVE_OPACITY } from '../../../../constants'
import { CreationToolsContext } from '../../../../manager'
import CreationToolWelcomeButton, { welcomeButtonIcon } from '../../../../types/welcome-button'
import { WelcomeBlock } from '../../../blocks'
import { WelcomeButton } from '../../../buttons'
import { NewIcon } from '../../../icons'
import { Subtitle, Text } from '../../../typography'
import File from './file'
import Link from './link'

const New = styled(NewIcon)``

const BaseBlock = styled(WelcomeBlock)`
    padding: 0;

    &:active {
        opacity: ${BUTTON_ACTIVE_OPACITY};
    }

    > div,
    > a {
        box-sizing: border-box;
        display: flex;
        width: 100%;
    }

    svg {
        height: 40px;
    }

    ${New} {
        height: auto;
    }
`

const ColumnBlock = styled(BaseBlock)`
    text-align: center;

    > div,
    > a {
        flex-direction: column;
        height: 100%;
        padding-top: 20px;
    }

    ${Subtitle}, ${Text} {
        margin-left: 30px;
        margin-right: 30px;
    }

    ${Text} {
        margin-bottom: 20px;
    }

    ${WelcomeButton} {
        margin-top: auto;
    }

    svg {
        margin: 0 auto 15px;
    }

    ${New} {
        position: absolute;
        right: 10px;
        top: 10px;
    }
`

const RowBlock = styled(BaseBlock)`
    > div,
    > a {
        align-items: center;
        padding: 15px 20px;
    }

    svg,
    ${Subtitle}, ${Text}, ${New} {
        line-height: 1;
        margin: 0 10px 0 0;
    }

    ${WelcomeButton} {
        margin-left: auto;
    }
`

type Props = {
    className?: string
    button: CreationToolWelcomeButton
    horizontal?: boolean
}

const CreationToolsWelcomeButton = ({ className, button, horizontal }: Props) => {
    const { user } = useContext(UserContext)
    const { isDraggingFile } = useContext(CreationToolsContext)
    const title = CreationToolWelcomeButton.title(button)
    const description = CreationToolWelcomeButton.description(button, user.isStaff)
    const url = CreationToolWelcomeButton.url(button)
    const isNew = CreationToolWelcomeButton.isNew(button)
    const Icon = welcomeButtonIcon(button)
    const Container = horizontal ? RowBlock : ColumnBlock
    const Wrapper = url ? Link : File

    return (
        <Container className={className}>
            <Wrapper button={button}>
                {Icon && <Icon />}
                <Subtitle as="h3">{title}</Subtitle>
                {description && <Text>{description}</Text>}
                {isNew && <New />}
                <WelcomeButton>{url ? `Open ${title}` : `${isDraggingFile ? 'Drop' : 'Choose'} File`}</WelcomeButton>
            </Wrapper>
        </Container>
    )
}

export default CreationToolsWelcomeButton
